import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const VideoIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "currentColor",
  width = 13,
  height = 8,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Video</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.867 0h-9.61C1.114 0 .187 1.045.187 2.333v8.334c0 1.288.927 2.333 2.07 2.333h9.61c1.143 0 2.07-1.045 2.07-2.333V2.333c0-1.288-.927-2.333-2.07-2.333Zm3.342 4.344a.48.48 0 0 0-.209.407v3.498c0 .169.08.325.209.407l6.061 3.86c.126.08.28.079.404-.005a.482.482 0 0 0 .2-.401V.89a.482.482 0 0 0-.2-.401.363.363 0 0 0-.404-.005l-6.061 3.86Z"
        fill={fill}
      />
    </svg>
  );
};

export default VideoIcon;
